export default __webpack_public_path__ + "static/media/bravio.786735ef.jpg";